import React, { useEffect, useState } from 'react';
import './FloatingBubble.css';

function FloatingBubble({ initialX, initialY, isUser, isLunaTyping }) {
  const [style, setStyle] = useState({});

  useEffect(() => {
    // Increase size range: now between 80px and 140px
    const size = Math.random() * 60 + 80;
    
    // Adjust angle range based on bubble type
    let angleRange;
    if (isUser) {
      // User bubbles: 0 to 60 degrees (going right and up)
      angleRange = Math.random() * 60;
    } else {
      // Luna bubbles: 180 to 240 degrees (going left and up from right side)
      angleRange = Math.random() * 60 + 180;
    }
    
    const angle = angleRange * (Math.PI / 180);
    // Increase distance range as well for better visibility
    const distance = Math.random() * 300 + 200;
    
    const finalX = Math.sin(angle) * distance;
    const finalY = -Math.abs(Math.cos(angle) * distance); // Ensure upward movement

    setStyle({
      left: initialX + 'px',
      top: initialY + 'px',
      width: size + 'px',
      height: size + 'px',
      transform: `translate(${finalX}px, ${finalY}px)`,
    });
  }, [initialX, initialY, isUser]);

  const bubbleClass = isLunaTyping 
    ? 'floating-bubble luna-typing'
    : `floating-bubble ${isUser ? '' : 'luna-bubble'}`;

  return (
    <div 
      className={bubbleClass}
      style={style}
    />
  );
}

export default FloatingBubble; 